<script>
  export let cta = 'Find out more'
  export let to = '/'
  export let className = null
  export let callback = null
</script>

<div class="link accent" on:click={ () => callback && callback() } >
  <span class="link__span">{cta}</span>
  <svg width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 12H32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M25 3.75L32.5 12L25 20.25" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</div>

<style lang="scss">
  :global(.link) {
    display: flex;
    align-items: center;
    white-space: nowrap;
    width: 8rem;
    width: fit-content;
    position: relative; 
    padding: 0.5rem 0;
    margin-bottom: .5rem;
    cursor: pointer;
    &::before {
      content: ""; 
      position: absolute;
      left: 30%;
      bottom: 0;
      height: 2px;
      width: 0;
      border-bottom: 2px solid var(--heading-colour);
      -webkit-transition: width .5s;
      transition: width .5s;
    }
    &:hover::before { 
      width: 70%; 
    }
    svg {
      height: 1rem;
      width: auto;
      margin-left: 0.75rem;
      stroke: #233348;
    }
    span {
      font-size: 1rem;
      font-weight: medium;
    }
    &.large {
      padding: 0.75rem 0;
      svg {
        margin-left: 1.625rem;
      }
      span {
        font-size: 1.25rem;
      }
    }
    &.accent {
      &::before {
        border-color: var(--accent-colour);
      }
      svg {
        stroke: var(--accent-colour);
      }
      span {
        color: var(--accent-colour);
      }
    }
  }
</style>